module.exports = ".holder1{\r\n    padding:20px 10px 0px;background:#808080;color:#fff;\r\n}\r\n\r\n.holder1 label{\r\n    color:#fff !important;\r\n}\r\n\r\n.title{\r\n    font-size:30px !important;\r\n}\r\n\r\n.table-title{\r\n    background-color:rgba(0, 0, 0, 0.05) !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/final-list/final-list.component.css
// module id = ./src/app/allocation/final-list/final-list.component.css
// module chunks = main